import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Routes, Navigate, Route, Outlet } from 'react-router-dom';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Route as SettingsAccountingIntegrationsRoute } from '~/core/routes/settings/accounting-integrations/_index';
import { Route as SettingsAssignmentEditStrategyRoute } from '~/core/routes/settings/assignment-strategy/[strategyId]/edit/_index';
import { Route as SettingsAssignmentStrategyRoute } from '~/core/routes/settings/assignment-strategy/_index';
import { Route as SettingsAssignmentCreateStrategyRoute } from '~/core/routes/settings/assignment-strategy/new/_index';
import { Route as SettingsBankAccountsRoute } from '~/core/routes/settings/bank-accounts/_index';
import { Route as SettingsBankIntegrationsRoute } from '~/core/routes/settings/bank-integrations/_index';
import { Route as SettingsUserRoute } from '~/core/routes/settings/my-account/_index';
import { Route as SettingsNotificationsRoute } from '~/core/routes/settings/notifications/_index';
import { Route as SettingsWebhookRoute } from '~/core/routes/settings/webhooks/_index';
import { LatestAssignmentPipelineRunMetadataForLpGroupingProvider } from '~/packages/loanProduct/hooks/LatestAssignmentPipelineRunMetadataForLpGroupingProvider';
import { LoanProductCreditFacilityGroupProvider } from '~/packages/loanProduct/hooks/LoanProductCreditFacilityGroupingProvider';

// Exports
export const SettingsRouter = () => {
  const { user } = useUserAuthOrThrow();

  return (
    // Paths relative to "/settings/*"
    <Routes>
      <Route path="/my-account" element={<SettingsUserRoute />} />
      <Route path="/integrations" element={<SettingsUserRoute />} />
      <Route path="/bank-accounts" element={<SettingsBankAccountsRoute />} />
      <Route
        path="/bank-integrations"
        element={<SettingsBankIntegrationsRoute />}
      />
      <Route
        path="/accounting-integrations"
        element={<SettingsAccountingIntegrationsRoute />}
      />
      <Route path="/notifications" element={<SettingsNotificationsRoute />} />
      <Route path="/webhooks" element={<SettingsWebhookRoute />} />
      {/* Need to wrap each provider in a Route, otherwise outlet doesn't know what to do with nested providers in the element prop */}
      <Route
        path="/assignment-strategy/*"
        element={
          <LoanProductCreditFacilityGroupProvider
            organizationId={user.organizationId}
            renderLoading={<Skeleton />}
            fallbackComponent={<Skeleton />}
          >
            <Outlet />
          </LoanProductCreditFacilityGroupProvider>
        }
      >
        <Route
          path="/assignment-strategy/*"
          element={
            <LatestAssignmentPipelineRunMetadataForLpGroupingProvider
              renderLoading={<Skeleton />}
            >
              <Outlet />
            </LatestAssignmentPipelineRunMetadataForLpGroupingProvider>
          }
        >
          <Route index element={<SettingsAssignmentStrategyRoute />} />
          <Route
            path="new"
            element={<SettingsAssignmentCreateStrategyRoute />}
          />
          <Route
            path=":strategyId/edit"
            element={<SettingsAssignmentEditStrategyRoute />}
          />
        </Route>
      </Route>
      <Route path="/*" element={<Navigate to="/settings/my-account" />} />
      <Route path="../slack/oauth_redirect" element={<SettingsUserRoute />} />
    </Routes>
  );
};
